import { useState } from "react";
import mbg1Img from "../assets/mbg1.png";
import mbg2Img from "../assets/mbg2.jpg";
import mbg3Img from "../assets/mbg3.png";
import mbg4Img from "../assets/mbg4.png";
import mbg5Img from "../assets/mbg5.jpg";
import mbg6Img from "../assets/mbg6.jpg";

export default function DailyFood() {
  const [hovered, setHovered] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHovered(true);
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setHovered(false);
    setActiveIndex(null);
  };

  return (
    <>
      <section className="text-gray-600 body-font">
        <div className="container px-5 py-24 mx-auto flex flex-wrap">
          <div className="flex w-full mb-20 flex-wrap">
            <h1 className="sm:text-3xl text-2xl font-medium title-font text-gray-900 lg:w-1/3 lg:mb-0 mb-4">
              Menu harian Makanan Bergizi <br />Gratis
            </h1>
            <p className="lg:pl-6 lg:w-2/3 mx-auto leading-relaxed text-xl">
              Sajian harian ini dibuat oleh tangan-tangan tulus warga asli Depok, yang setiap hari memasak dengan cinta dan kepedulian.
              Dari dapur sederhana, mereka menghadirkan hidangan bergizi sebagai wujud harapan agar anak-anak Depok tumbuh sehat, kuat, 
              dan berprestasi.
            </p>
          </div>

          <div className="flex flex-wrap md:-m-2 -m-1">
            <div className="flex flex-wrap w-1/2">
              <div className="md:p-2 p-1 w-1/2">
                <img
                  alt="gallery"
                  src={mbg1Img}
                  className={`w-full object-cover h-full object-center block rounded transition-all duration-300 ease-in-out
                    ${hovered && activeIndex !== 0 ? "blur-sm opacity-50" : ""}
                    ${activeIndex === 0 ? "scale-110 z-20" : ""}`}
                  onMouseEnter={() => handleMouseEnter(0)}
                  onMouseLeave={handleMouseLeave}
                />
              </div>
              <div className="md:p-2 p-1 w-1/2">
                <img
                  alt="gallery"
                  src={mbg2Img}
                  className={`w-full object-cover h-full object-center block rounded transition-all duration-300 ease-in-out
                    ${hovered && activeIndex !== 1 ? "blur-sm opacity-50" : ""}
                    ${activeIndex === 1 ? "scale-110 z-20" : ""}`}
                  onMouseEnter={() => handleMouseEnter(1)}
                  onMouseLeave={handleMouseLeave}
                />
              </div>
              <div className="md:p-2 p-1 w-full">
                <img
                  alt="gallery"
                  src={mbg3Img}
                  className={`w-full h-full object-cover object-center block rounded transition-all duration-300 ease-in-out
                    ${hovered && activeIndex !== 2 ? "blur-sm opacity-50" : ""}
                    ${activeIndex === 2 ? "scale-110 z-20" : ""}`}
                  onMouseEnter={() => handleMouseEnter(2)}
                  onMouseLeave={handleMouseLeave}
                />
              </div>
            </div>

            <div className="flex flex-wrap w-1/2">
              <div className="md:p-2 p-1 w-full">
                <img
                  alt="gallery"
                  src={mbg4Img}
                  className={`w-full h-full object-cover object-center block rounded transition-all duration-300 ease-in-out
                    ${hovered && activeIndex !== 3 ? "blur-sm opacity-50" : ""}
                    ${activeIndex === 3 ? "scale-110 z-20" : ""}`}
                  onMouseEnter={() => handleMouseEnter(3)}
                  onMouseLeave={handleMouseLeave}
                />
              </div>
              <div className="md:p-2 p-1 w-1/2">
                <img
                  alt="gallery"
                  src={mbg5Img}
                  className={`w-full object-cover h-full object-center block rounded transition-all duration-300 ease-in-out
                    ${hovered && activeIndex !== 4 ? "blur-sm opacity-50" : ""}
                    ${activeIndex === 4 ? "scale-110 z-20" : ""}`}
                  onMouseEnter={() => handleMouseEnter(4)}
                  onMouseLeave={handleMouseLeave}
                />
              </div>
              <div className="md:p-2 p-1 w-1/2">
                <img
                  alt="gallery"
                  src={mbg6Img}
                  className={`w-full object-cover h-full object-center block rounded transition-all duration-300 ease-in-out
                    ${hovered && activeIndex !== 5 ? "blur-sm opacity-50" : ""}
                    ${activeIndex === 5 ? "scale-110 z-20" : ""}`}
                  onMouseEnter={() => handleMouseEnter(5)}
                  onMouseLeave={handleMouseLeave}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
